import { AdditionalOrderColumn, OrdersTab } from 'enums';
import { useOrderQueryFilters } from 'hooks';

import { DisputeOrders } from '../DisputeOrders';

export const TraderDisputeOrders: React.FC = () => {
  useOrderQueryFilters();
  return (
    <DisputeOrders
      tab={OrdersTab.TraderDispute}
      additionalColumns={[
        AdditionalOrderColumn.Trader,
        AdditionalOrderColumn.Dispute,
      ]}
    />
  );
};
